import { z } from 'zod'

export const loginProviderEnum = z.enum(['google', 'microsoft'])

export const loginFormSchema = z.object({
  provider: loginProviderEnum,
  redirectTo: z.string(),
})
